module.exports = __webpack_public_path__ + "static/media/home-1.f9b8b306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-1.jpg
// module id = 260
// module chunks = 0